import { React } from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faLocationDot, faClock } from '@fortawesome/free-solid-svg-icons';
import './ContactPage.css';

function ContactPage() {
    // Animation for motion divs
    const fadeInUp = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.6 }
    };

    return (
        <div className="contact-page">
            <div className="contact-container">
                <motion.div className="contact-information"
                {...fadeInUp}
                transition={{ delay: 0.2 }}>
                    <h1>Contact Information</h1>
                    <h3><FontAwesomeIcon icon={faEnvelope} /> support@enablegames.com</h3>
                    <h3><FontAwesomeIcon icon={faPhone} /> (215) 703-7537</h3>
                    <h3><FontAwesomeIcon icon={faLocationDot} /> 3401 Market Street, Suite 200, Philadelphia, PA 19104</h3>
                    <h3><FontAwesomeIcon icon={faClock} /> Monday – Friday: 9:00 AM to 5:00 PM</h3>
                </motion.div>
                <motion.div className="contact-us"
                {...fadeInUp}
                transition={{ delay: 0.3 }}>
                    <h1>Contact Us</h1>
                    <form>
                        <label for="fname">First name: (required)</label>
                        <input type="text" id="fname" name="fname" required/>
                        <label for="lname">Last name: (required)</label>
                        <input type="text" id="lname" name="lname" required/>
                        <label>Phone Number: (required)</label>
                        <input type="text" id="phone-num" name="phone-num" required/>
                        <label>Email Address: (required)</label>
                        <input type="text" id="email" name="email" required/>
                        <label>Your Message: </label>
                        <textarea id="message" name="message" rows="20" cols="40" required/>
                        <input id="submit" type="submit" value="Send Message"/>
                    </form>
                </motion.div>
            </div>
        </div>
    );
}

export default ContactPage;